import { ObjectTools } from '../../../tools/object-tools';
import { SolText } from '../../../models/core/sol-text';
import { SolTable, TableStyle } from '../../../models/overview/sol-table';

export class SolReportTableState<S> {
  private constructor(
    public readonly table: SolTable<S> | undefined,
    public readonly summary: SolText | undefined,
    /**
     * Grid template for the read-only table. Unlike the interactive `sol-table`
     * (`minmax(max-content, auto)` → horizontal scroll), report columns are
     * `minmax(0, auto)` so they shrink and wrap to fit the container width.
     */
    public readonly tableStyle: TableStyle,
  ) {}

  public static of<S>(): SolReportTableState<S> {
    return new SolReportTableState<S>(undefined, undefined, {});
  }

  public withTable(table: SolTable<S> | undefined): SolReportTableState<S> {
    if (ObjectTools.equals(this.table, table)) return this;
    return this.copy({ table }).recalculateTableStyle();
  }

  public withSummary(summary: SolText | undefined): SolReportTableState<S> {
    if (ObjectTools.equals(this.summary, summary)) return this;
    return this.copy({ summary });
  }

  private recalculateTableStyle(): SolReportTableState<S> {
    const columns = this.table?.columns ?? [];
    const gridTemplateColumns = ['min-content', ...columns.map(() => 'minmax(0, auto)')].join(' ');
    if (this.tableStyle.gridTemplateColumns === gridTemplateColumns) return this;
    return this.copy({ tableStyle: { gridTemplateColumns } });
  }

  private copy(props: Partial<SolReportTableState<S>>): SolReportTableState<S> {
    return ObjectTools.copy<SolReportTableState<S>>(this, props);
  }
}
